import React from "react"
import { Typography } from "@material-ui/core"
import clsx from "clsx"
import useStyles from "@/components/ProductReportClient/styles"
import { Link } from "react-router-dom"
import useContactDisplay from "@/hooks/useContactDisplay"
import { buildChatLink } from "@/utils/chat"

export type PhoneNumberRedirectProps = {
	phoneNumber: string
	clientId: number
	customizedClass?: string
	customLinkTarget?: string
}

const PhoneNumberRedirect: React.FC<PhoneNumberRedirectProps> = (props) => {
	const { phoneNumber, clientId, customizedClass, customLinkTarget } = props
	const classes = useStyles()
	const { getDisplayPhoneNumber } = useContactDisplay()

	const chatLink = buildChatLink(clientId)

	return (
		<>
			{
				<Link to={chatLink} target={customLinkTarget || "_blank"} style={{ textDecoration: "none" }}>
					<Typography
						className={`${clsx({
							[classes.contact]: true
						})} ${customizedClass}`}
					>
						{getDisplayPhoneNumber(phoneNumber)}
					</Typography>
				</Link>
			}
		</>
	)
}

export default PhoneNumberRedirect
